import { clone } from "../../utilities/clone.js";
export class ReadOnlyMemoryStore {
    resources;
    constructor(resources) {
        this.resources = resources;
    }
    static create(resources) {
        return new ReadOnlyMemoryStore(resources);
    }
    listResources() {
        return Object.keys(this.resources);
    }
    listResourcesOfType(typeIri) {
        const result = [];
        for (const [iri, resource] of Object.entries(this.resources)) {
            if (resource.types.includes(typeIri)) {
                result.push(iri);
            }
        }
        return result;
    }
    readResource(iri) {
        const resource = this.resources[iri];
        if (resource === undefined) {
            return null;
        }
        return clone(this.resources[iri]);
    }
}
//# sourceMappingURL=read-only-memory-store.js.map